import { withPageLoadingRecovery } from '@forest/native-services'
import type { UserInfoSource } from '@forest/paywall-core'

/**
 * Re-enters the shared user-info source through the one page-loading recovery
 * mechanism, so a lost or timed-out bridge reply is retried inside the original
 * budget without the initializer seeing an intermediate failure.
 */
export function getUserInfoWithRecovery(
  source: UserInfoSource,
): Promise<Awaited<ReturnType<UserInfoSource['getReady']>>> {
  return withPageLoadingRecovery(() => source.getReady())
}
